import { ReportColumnConfig } from "components/ReportGrid_New/types";

export const SMS_REPORT_TITLE = 'smsReport';
export const SMS_REPORT_NAME = 'SMS Report';

export const columns: ReportColumnConfig[] = [
  { name: 'repairerName', title: 'Repairer Name', width: '200' },
  { name: 'schemeCode', title: 'Scheme Code' },
  { name: 'claimReference', title: 'Claim Ref.' },
  { name: 'regMark', title: 'Vehicle Reg.' },
  { name: 'messageType', title: 'Message Type' },
  { name: 'messageDescription', title: 'Message Description', width: '200' },
  { name: 'messageDate', title: 'Message Date', type: 'date' },
  { name: 'messageTime', title: 'Message Time' },
  { name: 'smsBody', title: 'SMS Body', width: '150' },
];

export const summaryItems = [{ columnName: 'repairerName', type: 'count', customizeText: ({value}: {value: string | number | Date})  => `Total Messages: ${value}`}];
